const useRetornaDataVencimento = ({ formik: propsFormik }) => {
  const { values, setFieldValue } = propsFormik;

  const onBlurReferencia = () => {
    const referencia = values.txReferencia || ""; // Acesse o campo específico dentro de values
    const numeros = referencia.replace(/\D/g, ""); // Remover caracteres não numéricos
    let dia;
    let mes;
    let ano;
    let vOk;

    if (numeros.length === 6) {
      mes = numeros.substring(0, 2);
      ano = numeros.substring(2, 6);

      vOk = true;
    } else if (numeros.length === 8) {
      dia = numeros.substring(0, 2);
      mes = numeros.substring(2, 4);
      ano = numeros.substring(4, 8);
      vOk = true;
    } else {
      vOk = false;
    }

    if (vOk) {
      // Se não houver dia, assume-se que é 01
      dia = dia || "01";
      // Criar a data base no formato YYYY-MM-DD
      const data = new Date(ano, mes - 1, dia); // mes - 1 porque os meses começam em 0

      // Adicionar um mês
      data.setMonth(data.getMonth() + 1);

      // Ajustar para o dia 15
      data.setDate(15);

      // Formatar a nova data para YYYY-MM-DD
      const novaData = data.toISOString().split("T")[0];

      setFieldValue("dtVencimento", novaData);
    } else {
      setFieldValue("dtVencimento", "");
    }
  };

  return { onBlurReferencia };
};

export default useRetornaDataVencimento;
